export default {
  showDropdown: {
    powertrain: false,
    safety: false,
    bodyComfort: false,
    consumerApplications: false,
    eBikes2Wheeler: false,
    robotics: false,
    drones: false,
  },
  dropdownContent: {
    col_one_color: "#F39864",
    col_two_color: "#AFCFC6",
    safetyContent: [
      ["Brake & chassis control", "/brake-chassis-control"],
      ["Electric Power Steering", "/electric-power-steering"],
      ["Exterior sound sensing", "/mems-microphones-for-automative"],
      ["Pedals", "/pedals"],
      ["Radar-based\ndriver assistance", "/radar-driver-assistance"],
      ["SAB/\nPedestrian protection", "/sab"],
      ["Seat belt pretensioner", "/seat-belt-pretensioner"],
      ["TMPS", "/tpms"],
      ["Wheel speed", "/wheel-speed"],
    ],
    bodyComfortContent: [
      ["Adaptive lighting", "/adaptive-lighting"],
      ["Comfort driving", "/comfort-driving"],
      ["Control elements", "/control-elements"],
      ["In cabin sound sensing", "/in-cabin-sound-sensing"],
      ["Seat position", "/seat-position"],
      ["Trunk gate", "/trunk-gate"],
      ["Window lift/sunroof", "/window-lift"],
      ["Wipers", "/wipers"],
    ],
    consumerApplicationsContent: [
      ["Motor position sensing", "/motor-position-sensing"],
      ["Gimbals", "/gimbals"],
      ["Position detection", "/position-detection"],
      ["Power tools", "/power-tools"],
      ["PV inverters and modules", "/pv-inverters-modules"],
      ["Smart home displays", "/smart-home-displays"],
      ["Smart HVAC", "/smart-hvac"],
      ["Smart lighting", "/smart-lighting"],
      ["Smart lock", "/smart-lock"],
      ["Smart metering", "/smart-metering"],
      ["Smart speaker", "/smart-speaker"],
      ["White goods", "/white-goods"],
    ],
    eBikes2WheelerContent: [
      ["Combustion Engine", "/2-wheeler-combustion-engine"],
      ["Combustion Engine Control", "/2-wheeler-combustion-engine-control"],
    ],
    roboticsContent: [
      ["Industrial robotics", "/industrial-robotics"],
      ["Personal service robotics", "/personal-service-robotics"],
    ],
    dronesContent: [
      ["Control", "/drones-control"],
      ["Overcurrent detection", "/drones-overcurrent-detection"],
    ],
  },
};
